import { render, staticRenderFns } from "./SelectTagsModal.vue?vue&type=template&id=de9b9cc6&"
import script from "./SelectTagsModal.vue?vue&type=script&lang=js&"
export * from "./SelectTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectTagsModal.vue?vue&type=style&index=0&id=de9b9cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports